import random from "lodash/random";

export const getHitPoints = () => random(1, 8);
